import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_GUIDES_QUERY,
  CREATE_TRAVEL_GUIDE_MUTATION,
  DELETE_TRAVEL_GUIDE_MUTATION,
  FORCE_DELETE_TRAVEL_GUIDE_MUTATION,
  SINGLE_TRAVEL_GUIDE_QUERY,
  UPDATE_TRAVEL_GUIDE_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const travelGuideModel: EntityModel = {
  name: 'travelGuide',
  namePlural: 'travelGuides',
  uniqueName: 'travelGuide',
  uniqueNamePlural: 'travelGuides',
  path: 'travel/travel_guide',
  baseUrl: '/travel/travel-guides',
  translationPrefix: 'entities:travelGuide.',
  getDisplayName: (values: any) => {
    return `${values.firstName} ${values.lastName}`
  },
  gql: {
    getAll: ALL_TRAVEL_GUIDES_QUERY,
    getSingle: SINGLE_TRAVEL_GUIDE_QUERY,
    create: CREATE_TRAVEL_GUIDE_MUTATION,
    update: UPDATE_TRAVEL_GUIDE_MUTATION,
    delete: DELETE_TRAVEL_GUIDE_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_GUIDE_MUTATION,
  },
  attributes: {
    firstName: {
      name: 'firstName',
      label: 'entities:travelGuide.attributes.firstName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    lastName: {
      name: 'lastName',
      label: 'entities:travelGuide.attributes.lastName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:travelGuide.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    image: {
      name: 'image',
      label: 'entities:travelGuide.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelGuideModel
